import React, { useContext } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../components/lm-d-s/head-container';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const lineList = [
  {
    image: getImageFromS3('images/lm-double-splash/line/1.png'),
    title: 'Компакт\n' + 'З капсулою'
  },
  {
    image: getImageFromS3('images/lm-double-splash/line/2.png'),
    title: 'Компакт'
  },
  {
    image: getImageFromS3('images/lm-double-splash/line/3.png'),
    title: 'Кінг Сайз'
  },
  {
    image: getImageFromS3('images/lm-double-splash/line/4.png'),
    title: 'Кінг Сайз\n' + '40 шт. у пачці'
  }
];

const LmLineScreen = ({ setScreenNumber }) => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div
      className={styles.screenContainer}
      style={{
        backgroundImage: `url("${getImageFromS3(
          'images/lm-double-splash/menu-background.png'
        )}")`
      }}
    >
      <HeadContainer setScreenNumber={setScreenNumber} />
      <span className={styles.title}>Лінійка L&M</span>
      <div className={styles.lineContainer}>
        {lineList.map((item, index) => (
          <div key={index.toString()} className={styles.lineItem}>
            <img src={item.image} alt={item.image} />
            <span>
              <p>{item.title}</p>
            </span>
          </div>
        ))}
      </div>
      <p className={styles.description}>
        Актуальний асортимент можна знайти на офіційних онлайн сервісах або у
        роздрібних точках продажу в твоєму місті
      </p>
      <div className={styles.linkButtonContainer}>
        <a
          className={styles.linkButton}
          href="https://cig-poshta.in.ua/shop/lm/"
          target="_blank"
          onClick={() => sendEvent('cig-poshta')}
        >
          Cig-poshta
        </a>
        <a
          className={styles.linkButton}
          href="https://rozetka.com.ua/ua/sigareti/c4638591/producer=b84d5fce/"
          target="_blank"
          onClick={() => sendEvent('rozetka')}
        >
          Rozetka
        </a>
      </div>
      <button
        className={styles.continueButton}
        onClick={() => setScreenNumber(10)}
      >
        Далі
      </button>
    </div>
  );
};

export default LmLineScreen;
